

export const INFO_DATA = [
    { id: 0, originalData: "CAT", title: "Category", koreanTitle: "분류" },
    { id: 1, originalData: "COUNTRY", title: "Country", koreanTitle: "국가" },
    { id: 2, originalData: "WEBSITE", title: "Website", koreanTitle: "웹사이트" },
    { id: 3, originalData: "SECTOR", title: "Sector", koreanTitle: "분야" },
    { id: 4, originalData: "INDUSTRY", title: "Industry", koreanTitle: "산업" },
    { id: 5, originalData: "LONG_BUSINESS SUMMARY", title: "Busniess summary", koreanTitle: "사업 개요" },
    { id: 6, originalData: "TOTAL_REVENUE", title: "Total revenue", koreanTitle: "매출액" },
    { id: 7, originalData: "GROSS_PROFITS", title: "Gross profits", koreanTitle: "매출 총이익" },
    { id: 8, originalData: "NET_INCOME_TO_COMMON", title: "Net income to common", koreanTitle: "당기순이익" },
    { id: 9, originalData: "ETITDA", title: "Ebitda", koreanTitle: "Ebitda" },
    { id: 10, originalData: "REVENUE_GROWTH", title: "Revenue growth", koreanTitle: "매출액 성장률" },
    { id: 11, originalData: "EARNING_GROWTH", title: "Earning growth", koreanTitle: "수익 증가율" },
    { id: 12, originalData: "CURRENT_RATIO", title: "Current Ratio", koreanTitle: "유동비율" },
    { id: 13, originalData: "DEBT_TO_EQUITY", title: "Debt to equity", koreanTitle: "부채비율" },
    { id: 14, originalData: "FORWARD_EPS", title: "Forward EPS", koreanTitle: "선행 EPS" },
    { id: 15, originalData: "TRAILING_EPS", title: "Trailing EPS", koreanTitle: "후행 EPS" },
    { id: 16, originalData: "BOOK_VALUE", title: "Book Value Ratio", koreanTitle: "순자산 비율" },
    { id: 17, originalData: "PRICE_TO_BOOK", title: "Price to book", koreanTitle: "PBR" },
    { id: 18, originalData: "ROE", title: "ROE", koreanTitle: "ROE" },
    { id: 19, originalData: "BETA", title: "BETA", koreanTitle: "베타 계수" },
    { id: 20, originalData: "TOTAL_LIDAB", title: "Total Lidab", koreanTitle: "부채" },
    { id: 21, originalData: "RETAINED_EARNINGS", title: "Retained earnings", koreanTitle: "이익잉여금" },
    { id: 22, originalData: "CASH", title: "Cash", koreanTitle: "현금" },
    { id: 23, originalData: "INVENTORY", title: "Inventory", koreanTitle: "재고" },
    { id: 24, originalData: "DIVIDEND_YIELD", title: "Dividend yield", koreanTitle: "배당 수익률" },
    { id: 25, originalData: "ENTERPRISE_VALUE", title: "Enterprise value", koreanTitle: "기업 가치" },
    { id: 26, originalData: "EPS", title: "EPS", koreanTitle: "EPS" },
    { id: 27, originalData: "PER", title: "PER", koreanTitle: "PER" },
    { id: 28, originalData: "ROA", title: "ROA", koreanTitle: "ROA" },
    { id: 29, originalData: "QUICK_RATIO", title: "Quick ratio", koreanTitle: "당좌비율" },
    { id: 30, originalData: "Category", title: "Category", koreanTitle: "분류" },
    { id: 31, originalData: "MaxSupply", title: "Max Supply", koreanTitle: "최대 공급량" },
    { id: 32, originalData: "TotalSupply", title: "Total Supply", koreanTitle: "총 공급량" },
    // {id:33, originalData:"description", title:"Description", koreanTitle:"설명"},
    { id: 34, originalData: "tags", title: "Tags", koreanTitle: "태그" },
    { id: 35, originalData: "whitepaper", title: "White Paper", koreanTitle: "백서" },

]

export const DETAILS = [
    { id: 0, title: "Location", content: "United States", bold: true },
    { id: 1, title: "Exchange", content: "NASDAQ", bold: true },
    { id: 2, title: "Sector", content: "Information Technology", bold: true },
    { id: 3, title: "Total Cash", content: "48,304,001,024" },
    { id: 4, title: "Total Debt", content: "132,480,000,000" },
    { id: 5, title: "Total Revenue", content: "394,328,014,848" },
    { id: 6, title: "EBITDA", content: "130,541,002,752" },
    { id: 7, title: "Debt to Equity", content: "261.446" },
    { id: 8, title: "Revenue per Share", content: "24.317" },
    { id: 9, title: "Gross Profit", content: "170,782,000,000" },
    { id: 10, title: "Free Cash Flow", content: "90,215,251,968" },
    { id: 11, title: "Revenue Growth", content: "8.10%" },
    { id: 12, title: "Category", content: "Token", bold: true },
    { id: 13, title: "Platform", content: "Ethereum", bold: true },
    { id: 14, title: "Total Supply", content: "20,000,000,000" },
    { id: 15, title: "Max Supply", content: "40,000,000,000" },
    {
        id: 16,
        title: "Whitepaper",
        content: "https://www.stellar.org/papers/stellar-consensus-protocol.pdf",
        underline: true,
    },
    { id: 17, title: "Tags", content: "smart-contracts, medium of exchange" },
    {
        id: 18,
        title: "Description",
        content:
            "Stellar (XLM) is a cryptocurrency . Stellar has a current supply of 50,001,787,506.607185 with 26,153,823,528.171074 in circulation. The last known price of Stellar is 0.07962521 USD and is up 0.23 over the last 24 hours. It is currently trading on 473 active market(s) with $63,225,097.83 traded over the last 24 hours. More information can be found at https://www.stellar.org.",
    },
];
export const DETAILS_CRYPTO = [
    { id: 0, title: "Category", content: "Token", bold: true },
    { id: 1, title: "Platform", content: "Ethereum", bold: true },
    { id: 2, title: "Total Supply", content: "20,000,000,000" },
    { id: 3, title: "Max Supply", content: "40,000,000,000" },
    {
        id: 4,
        title: "Whitepaper",
        content: "https://www.stellar.org/papers/stellar-consensus-protocol.pdf",
        underline: true,
    },
    { id: 5, title: "Tags", content: "smart-contracts, medium of exchange" },
    {
        id: 6,
        title: "Description",
        content:
            "Stellar (XLM) is a cryptocurrency . Stellar has a current supply of 50,001,787,506.607185 with 26,153,823,528.171074 in circulation. The last known price of Stellar is 0.07962521 USD and is up 0.23 over the last 24 hours. It is currently trading on 473 active market(s) with $63,225,097.83 traded over the last 24 hours. More information can be found at https://www.stellar.org.",
    },
];
export const DETAILS_STOCK = [
    { id: 0, title: "Location", content: "United States", bold: true },
    { id: 1, title: "Exchange", content: "NASDAQ", bold: true },
    { id: 2, title: "Sector", content: "Information Technology", bold: true },
    { id: 3, title: "Total Cash", content: "48,304,001,024" },
    { id: 4, title: "Total Debt", content: "132,480,000,000" },
    { id: 5, title: "Total Revenue", content: "394,328,014,848" },
    { id: 6, title: "EBITDA", content: "130,541,002,752" },
    { id: 7, title: "Debt to Equity", content: "261.446" },
    { id: 8, title: "Revenue per Share", content: "24.317" },
    { id: 9, title: "Gross Profit", content: "170,782,000,000" },
    { id: 10, title: "Free Cash Flow", content: "90,215,251,968" },
    { id: 11, title: "Revenue Growth", content: "8.10%" },
];

export const MENU_LIST = [
    { id: 0, title: "1W", koreanTitle: "1주" },
    { id: 1, title: "2W", koreanTitle: "2주" },
    { id: 2, title: "1M", koreanTitle: "1달" },
    // { id: 3, title: "3M", koreanTitle: "3달" },
    { id: 5, title: "1Y", koreanTitle: "1년" },
    { id: 6, title: "All", koreanTitle: "모두" },
];




export const DOWNLOAD = {
    data: [
        { id: 0, title: "All" },
        { id: 1, title: "Price" },
        { id: 2, title: "Tail Risk" },
    ],
    level: [
        { id: 0, title: "All" },
        { id: 1, title: "0.99" },
        { id: 2, title: "0.95" },
        { id: 3, title: "Others" },
    ],
};

export const RISK_INDEX = [
    { id: 0, title: "0.99" },
    { id: 1, title: "0.95" },
];

export const RISK_DATA = [
    { id: 0, title: "Tail Risk", amount: "0.0004" },
    { id: 1, title: "VAR", amount: "0.0699" },
    { id: 2, title: "CVAR", amount: "0.6910" },
];